import {
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_FAILED,
    NONUSER_CHARGE_STATUS_REVOKED,
    NONUSER_CHARGE_STATUS_SUCCESS,

    NONUSER_CHARGE_EXPENSE_TYPE_LOSS,
    NONUSER_CHARGE_EXPENSE_TYPE_REPAIR,

    NONUSER_ERROR_TITLE_OUT_OF_RANGE,
    NONUSER_ERROR_AMOUNT_OUT_OF_RANGE
} from 'constants/nonuser-charge';

const nonuserChargeStatus = {
    [NONUSER_CHARGE_STATUS_UNPAID]: 'Unpaid',
    [NONUSER_CHARGE_STATUS_SUCCESS]: 'Paid',
    [NONUSER_CHARGE_STATUS_FAILED]: 'Payment Failed',
    [NONUSER_CHARGE_STATUS_REVOKED]: 'Revoked',
};

const nonuserExpenseType = {
    [NONUSER_CHARGE_EXPENSE_TYPE_LOSS]: 'Operating Loss',
    [NONUSER_CHARGE_EXPENSE_TYPE_REPAIR]: 'Repair',
}

const nonuser_charge = {
    'new': 'New Charge',
    'details': 'Details',
    'status': 'Status',
    'case_name': 'Case Name',
    'nonuser_charge_status_map': nonuserChargeStatus,
    'nonuser_expense_type_map': nonuserExpenseType,
    'expense_type': 'Charge Type',
    'payment_link': 'Payment Link',
    'create_time': 'Created Time',
    'invalid_link': 'Link expired',
    'revoke_fee': 'Revoke',
    'revoke_warning': 'Are you sure you want to revoke this charge?',
    [`create_error_message_${ NONUSER_ERROR_TITLE_OUT_OF_RANGE }`]: 'Case name exceeds the allowable length.',
    [`create_error_message_${ NONUSER_ERROR_AMOUNT_OUT_OF_RANGE }`]: 'The amount exceeds the allowable range.',
};

export default nonuser_charge;
